import React, { useState } from 'react';
import { StyleSheet, TouchableOpacity, Text, View } from 'react-native';
import { ExpenseFormInput } from './ExpenseFormItem';
import { Color, CommonProperties, FontSize } from '../../styles';
import { setExpenseValue } from '../../store/actions/expense';
import { useDispatch } from 'react-redux';
import Icon from '../Icon';
import { useNavigation } from '@react-navigation/native';
import { scale } from '../../utils/scale.utils';

const ExpenseParticipantModal = ({ route }) => {
  const { stateName, actionType, subTab, value } = route.params;
  const dispatch = useDispatch();
  const [name, setName] = useState('');
  const navigation = useNavigation();
  const [participants, setParticipants] = useState(value || []);

  const handleAddParticipant = () => {
    if (name) {
      setParticipants([...participants, name]);
      setName('');
    }
  };

  const handleSubmitParticipants = () => {
    dispatch(setExpenseValue({ actionType, subTab, key: stateName, value: participants }));
    navigation.goBack();
  };

  const handleOnRemove = (index) => {
    const newParticipants = participants.filter((_, i) => i !== index);
    setParticipants(newParticipants);
  };

  return (
    <View>
      <View style={styles.row}>
        <ExpenseFormInput
          key={stateName}
          placeholder={'Participant'}
          value={name}
          onChangeText={(text) => {
            const validText = text.replace(/[0-9]/g, '');
            setName(validText);
          }}
          icon={'addPerson'}
          style={styles.input}
          label={'Participant'}
          fromExpenseFormFields={true}
        />
        <View style={styles.addParticipant}>
          <TouchableOpacity onPress={handleAddParticipant}>
            <Text style={styles.buttonText}>Add</Text>
          </TouchableOpacity>
        </View>
      </View>
      <View>
        {participants.length > 0 &&
          participants.map((participant, index) => (
            <View key={index} style={styles.list}>
              <View>
                <Text style={styles.participantText}>{participant}</Text>
              </View>
              <View>
                <TouchableOpacity onPress={() => handleOnRemove(index)}>
                  <Icon name="cancel" style={styles.closeIcon} />
                </TouchableOpacity>
              </View>
            </View>
          ))}
      </View>
      <View style={styles.divider} />
      <View style={styles.button}>
        <TouchableOpacity onPress={handleSubmitParticipants}>
          <Text style={styles.text}>Add Participants</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    ...CommonProperties.py3,
  },
  participantText: {
    fontSize: FontSize.h2,
  },
  input: {
    ...CommonProperties.shadow,
    ...CommonProperties.borderRadius2,
    width: scale(250),
  },
  button: {
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    ...CommonProperties.px5,
    ...CommonProperties.py3,
    ...CommonProperties.mt5,
    backgroundColor: Color.primary,
    ...CommonProperties.borderRadius4,
  },
  list: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    ...CommonProperties.mt2,
    backgroundColor: Color.lightGray,
  },
  buttonText: {
    color: Color.accent,
    fontSize: FontSize.h3,
  },
  closeIcon: {
    color: Color.gray,
    fontSize: scale(20),
  },
  text: {
    color: Color.accent,
    fontSize: scale(20),
  },
  addParticipant: {
    backgroundColor: Color.primary,
    ...CommonProperties.py3,
    paddingHorizontal: scale(30),
    ...CommonProperties.borderRadius4,
  },
  divider: {
    borderBottomWidth: 1,
    borderColor: Color.formDividerColor,
    ...CommonProperties.mt3,
  },
});

export default ExpenseParticipantModal;
